import type { ReactNode, CSSProperties } from 'react';
import { useInView } from '../../hooks/useInView';
import { BRAND, FONTS } from '../../styles/tokens';

interface RevealProps {
  children: ReactNode;
  delay?: number;
  style?: CSSProperties;
}

export function Reveal({ children, delay = 0, style = {} }: RevealProps) {
  const [ref, visible] = useInView();
  return (
    <div
      ref={ref}
      style={{
        ...style,
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(28px)',
        transition: `opacity 0.65s ease ${delay}s, transform 0.65s ease ${delay}s`,
      }}
    >
      {children}
    </div>
  );
}

interface SectionLabelProps {
  children: ReactNode;
  center?: boolean;
  light?: boolean;
}

export function SectionLabel({ children, center, light }: SectionLabelProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20, justifyContent: center ? 'center' : 'flex-start' }}>
      <div style={{ width: 32, height: 2, background: BRAND.teal }} />
      <span style={{ fontFamily: FONTS.body, fontSize: 12, letterSpacing: '0.14em', textTransform: 'uppercase', color: BRAND.teal, fontWeight: 600 }}>
        {children}
      </span>
      {center && <div style={{ width: 32, height: 2, background: BRAND.teal }} />}
    </div>
  );
}
